import Vue from 'vue'
import Router from 'vue-router'
import Race from './views/Race.vue'
import Home from './views/Home.vue'
// import Silks from './views/Silks.vue'
import Api from './views/Api.vue'
import Futures from './views/Futures.vue'
import Sports from './views/Sports.vue'
import Terminals from './views/Terminals.vue'
import DynamicOdds from './views/DynamicOdds.vue'
import Settings from './views/Settings.vue'
import GlobalRaceNetwork from './views/GlobalRaceNetwork.vue'
import Audit from './views/Audit.vue'
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/race',
      name: 'race',
      component: Race
    },
    {
      path: '/api',
      name: 'api',
      component: Api
    },
    {
      path: '/grn',
      name: 'grn',
      component: GlobalRaceNetwork
    },
    {
      path: '/sports',
      name: 'sports',
      component: Sports
    },
    {
      path: '/futures',
      name: 'futures',
      component: Futures
    },
    {
      path: '/terminals',
      name: 'terminals',
      component: Terminals
    },
    {
      path: '/do',
      name: 'do',
      component: DynamicOdds
    },
    {
      path:'/audit',
      name:'audit',
      component:Audit
    },
    {
      path: '/settings',
      name: 'settings',
      component: Settings
    }
    /* {
      path: '/systemHealth',
      name: 'systemHealth',
      component: SystemHealth
    },
    {
      path: '/silks',
      name: 'silks',
      component: Silks
    } */
  ]
})
